<div class="widget-title">Payment Options</div>
<div #canvasWrapper class="canvasWrapper" style="margin:auto">
    <canvas [hidden]="noDataAvailable" class="canvasWrapper" id="payments-pie-chart"></canvas>
</div>